export var importVitally = function () {
    return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://cdn.vitally.io/vitally.js/v1/vitally.js";
        script.addEventListener("load", function () { return resolve(script); }, false);
        script.addEventListener("error", function () { return reject(script); }, false);
        document.body.appendChild(script);
    });
};
/* eslint-disable */
export var VITALLY_TOKEN = "ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmhkV1FpT2lJNU4yWTVNVE0xWkMxbE5qazNMVFJsT0RZdE9UUTVNaTFtTWpjMFl6ZGxPV1UzWVRjaUxDSmhjR2tpT2lKaGNHa2lMQ0p6WldNaU9pSm1NRFUxWlRVeFpTSjkuR1o5OWZnWlRzTzYxTklsaklBeGxLaHZ3NG5tZG1ra3FIcmlsOHBxMXNaQTo=";
export default (function () {
    !function (n, t, r) { for (var i = n[t] = n[t] || [], o = function (r) { i[r] = i[r] || function () { for (var n = [], t = 0; t < arguments.length; t++)
        n[t] = arguments[t]; return i.push([r, n]); }; }, u = 0, c = ["init", "user", "account", "track", "nps"]; u < c.length; u++) {
        o(c[u]);
    } }(window, "Vitally");
});
